import { Button } from './Button'

/** "101–200 / 전체 412" with 이전 / 다음. Draws nothing for an empty list and
 *  no buttons when everything fits on one page. */
export function Pager({ total, page, pageSize, onPage }: { total: number; page: number; pageSize: number; onPage: (page: number) => void }) {
  if (total === 0) return null
  const from = (page - 1) * pageSize + 1
  const to = Math.min(total, page * pageSize)
  const pages = Math.ceil(total / pageSize)
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 text-table">
      <p className="tabular-nums text-muted-foreground">
        {from.toLocaleString('ko-KR')}–{to.toLocaleString('ko-KR')} / 전체 {total.toLocaleString('ko-KR')}
      </p>
      {pages > 1 && (
        <div className="flex items-center gap-2">
          <Button size="sm" disabled={page <= 1} onClick={() => onPage(page - 1)}>
            이전
          </Button>
          <span className="tabular-nums text-muted-foreground">
            {page} / {pages}
          </span>
          <Button size="sm" disabled={page >= pages} onClick={() => onPage(page + 1)}>
            다음
          </Button>
        </div>
      )}
    </div>
  )
}
